export type FieldOption = { label: string; value: string|number|boolean };
export const statusOptions:FieldOption[] = [
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' },
];

export const trueFalseOptions:FieldOption[] = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
];

export const documentTypeOptions: FieldOption[] = [
    { label: 'Bill', value: 'Bill' },
    { label: 'Invoice', value: 'Invoice' },
    { label: 'Quotation', value: 'Quotation' },
];